// extracted by mini-css-extract-plugin
module.exports = {"footer":"YTLLbUDUmGiDH8oUVgY-Mw==","declaration":"_94A+pPm9y54QYPmPdXUOhA=="};